import { render, staticRenderFns } from "./RadicalBroadcast.vue?vue&type=template&id=28dc82fe&"
import script from "./RadicalBroadcast.vue?vue&type=script&lang=js&"
export * from "./RadicalBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./RadicalBroadcast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports